import { CandidateField } from '../enums';

export class CareTeamCandidateField {
  field: CandidateField;

  value = '';

  constructor(obj: any) {
    Object.assign(this, obj);
    this.field = CandidateField.byKey[obj.field] || obj.field;
  }
}

export default CareTeamCandidateField;
